function PrivacyPolicy() {
  return (
    <div className="p-6 pt-[10px]" style={{ marginTop: 'var(--nav-height)' }}>
      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Introduction</h2>
        <p className="text-gray-700">
          Welcome to our Privacy Policy page! When you use our web services, you
          trust us with your information. This Privacy Policy is meant to help
          you understand what data we collect, why we collect it, and what we do
          with it. This is important; we hope you will take time to read it
          carefully.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Information We Collect</h2>
        <p className="text-gray-700">
          We collect information to provide better services to all our users. We
          collect information in the following ways:
        </p>
        <ul className="list-disc list-inside text-gray-700">
          <li className="mb-2">
            Information you give us. For example, our services require you to
            sign up for an account. When you do, we’ll ask for personal
            information, like your name, email address, telephone number
          </li>
          <li className="mb-2">
            Information we get from your use of our services. We collect
            information about the services that you use and how you use them,
            like when you visit a website that uses our advertising services or
            you view and interact with our ads and content.
          </li>
        </ul>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-4">
          How We Use Information We Collect
        </h2>
        <p className="text-gray-700">
          We use the information we collect from all our services to provide,
          maintain, protect, and improve them, to develop new ones, and to
          protect our users. We also use this information to offer you tailored
          content – like giving you more relevant search results and ads.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Information We Share</h2>
        <p className="text-gray-700">
          We do not share personal information with companies, organizations,
          and individuals outside of our company unless one of the following
          circumstances applies:
        </p>
        <ul className="list-disc list-inside text-gray-700">
          <li className="mb-2">
            With your consent. We will share personal information with
            companies, organizations, or individuals outside of our company when
            we have your consent to do so.
          </li>
          <li className="mb-2">
            For legal reasons. We will share personal information with
            companies, organizations, or individuals outside of our company if
            we have a good-faith belief that access, use, preservation, or
            disclosure of the information is reasonably necessary to meet any
            applicable law, regulation, legal process, or enforceable
            governmental request.
          </li>
        </ul>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
